<template>
    <div id="generate" class="mdl-card mdl-shadow--2dp">
        <div class="mdl-card__title mdl-color--primary mdl-color-text--primary-contrast ">
            <h2 class="mdl-card__title-text">ランダム作成</h2>
        </div>
        <div class="card-content">
            上記のグラフの正規分布に従ってランダムな身長を生成します。<br>
            <mdl-textfield floating-label="下限確率" type="number" v-model="min" />% ～
            <mdl-textfield　floating-label="上限確率" type="number" v-model="max" />%
            <mdl-button class="mdl-button--raised" @click.native="generate">作成</mdl-button>
            <h3>プリセット</h3>
            <div class="flex">
                <span class="label">通常</span>
                <mdl-button class="mdl-button--raised" @click.native="setRange(0,1)">0%～100%</mdl-button>
                <mdl-button class="mdl-button--raised" @click.native="setRange(0,0.5)">0%～50%</mdl-button>
                <mdl-button class="mdl-button--raised" @click.native="setRange(0.5,1)">50%～100%</mdl-button>
            </div>
            <div class="flex">
                <span class="label">端無し</span>
                <mdl-button class="mdl-button--raised" @click.native="setRange(0.02,0.98)">2%～98%</mdl-button>
                <mdl-button class="mdl-button--raised" @click.native="setRange(0.02,0.5)">2%～50%</mdl-button>
                <mdl-button class="mdl-button--raised" @click.native="setRange(.50,.98)">50%～98%</mdl-button>
            </div>
            <div class="flex">
                <span class="label">6分割</span>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(0,1/6)">①</mdl-button>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(1/6,2/6)">②</mdl-button>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(2/6,3/6)">③</mdl-button>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(3/6,4/6)">④</mdl-button>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(4/6,5/6)">⑤</mdl-button>
                <mdl-button class="mdl-button--raised mini" @click.native="setRange(5/6,6/6)">⑥</mdl-button>
            </div>
        </div>
        <div class="card-content border">
            <span class="generated-height">{{generated}}cm</span> (全体の<span class="generated-height">{{heightPercent}}%</span>の位置)<br>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'generate',
        props: {
            average: Number,
            stddev: Number
        },
        data() {
            return {
                min: 0,
                max: 100,
                generated: 0,
            }
        },
        computed: {
            heightPercent() {
                return Math.round(getNorm2(x2z(this.generated, this.average, this.stddev)) * 1000) / 10;
            }
        },
        methods: {
            generate() {
                this.generated = Math.round(z2x(getNorm(getRandomArbitary(this.min / 100, this.max / 100)), this.average, this.stddev) * 10) / 10;
            },
            setRange(min, max) {
                this.min = Math.round(min * 100);
                this.max = Math.round(max * 100);
                this.generate();
            }
        }
    }
    // min から max までの乱数を返す関数
    function getRandomArbitary(min, max) {
        return Math.random() * (max - min) + min;
    }

    function x2z(x, ave, stddev) {
        return (x - ave) / stddev
    }

    function z2x(z, ave, stddev) {
        console.log(z, ave, stddev);
        return z * stddev + ave;
    }

    function getNorm(z) {
        for (let [k, v] of norm) {
            if (k > z) return v;
        }
        return 3.5;
    }
    function getNorm2(z) {
        for (let [k, v] of norm) {
            if (z < v) return k;
        }
        return 1;
    }

    const norm = new Map([
        [0.000232629, -3.5],
        [0.00024151, -3.49],
        [0.000250707, -3.48],
        [0.000260229, -3.47],
        [0.000270088, -3.46],
        [0.000280293, -3.45],
        [0.000290857, -3.44],
        [0.000301791, -3.43],
        [0.000313106, -3.42],
        [0.000324814, -3.41],
        [0.000336929, -3.4],
        [0.000349463, -3.39],
        [0.000362429, -3.38],
        [0.000375841, -3.37],
        [0.000389712, -3.36],
        [0.000404058, -3.35],
        [0.000418892, -3.34],
        [0.00043423, -3.33],
        [0.000450087, -3.32],
        [0.00046648, -3.31],
        [0.000483424, -3.3],
        [0.000500937, -3.29],
        [0.000519035, -3.28],
        [0.000537737, -3.27],
        [0.000557061, -3.26],
        [0.000577025, -3.25],
        [0.000597648, -3.24],
        [0.000618951, -3.23],
        [0.000640953, -3.22],
        [0.000663675, -3.21],
        [0.000687138, -3.2],
        [0.000711364, -3.19],
        [0.000736375, -3.18],
        [0.000762195, -3.17],
        [0.000788846, -3.16],
        [0.000816352, -3.15],
        [0.000844739, -3.14],
        [0.000874032, -3.13],
        [0.000904255, -3.12],
        [0.000935437, -3.11],
        [0.000967603, -3.1],
        [0.001000782, -3.09],
        [0.001035003, -3.08],
        [0.001070294, -3.07],
        [0.001106685, -3.06],
        [0.001144207, -3.05],
        [0.001182891, -3.04],
        [0.001222769, -3.03],
        [0.001263873, -3.02],
        [0.001306238, -3.01],
        [0.001349898, -3],
        [0.001394887, -2.99],
        [0.001441242, -2.98],
        [0.001488999, -2.97],
        [0.001538195, -2.96],
        [0.00158887, -2.95],
        [0.001641061, -2.94],
        [0.00169481, -2.93],
        [0.001750157, -2.92],
        [0.001807144, -2.91],
        [0.001865813, -2.9],
        [0.001926209, -2.89],
        [0.001988376, -2.88],
        [0.002052359, -2.87],
        [0.002118205, -2.86],
        [0.002185961, -2.85],
        [0.002255677, -2.84],
        [0.0023274, -2.83],
        [0.002401182, -2.82],
        [0.002477075, -2.81],
        [0.00255513, -2.8],
        [0.002635402, -2.79],
        [0.002717945, -2.78],
        [0.002802815, -2.77],
        [0.002890068, -2.76],
        [0.002979763, -2.75],
        [0.003071959, -2.74],
        [0.003166716, -2.73],
        [0.003264096, -2.72],
        [0.00336416, -2.71],
        [0.003466974, -2.7],
        [0.003572601, -2.69],
        [0.003681108, -2.68],
        [0.003792562, -2.67],
        [0.003907033, -2.66],
        [0.004024589, -2.65],
        [0.004145301, -2.64],
        [0.004269243, -2.63],
        [0.004396488, -2.62],
        [0.004527111, -2.61],
        [0.004661188, -2.6],
        [0.004798797, -2.59],
        [0.004940016, -2.58],
        [0.005084926, -2.57],
        [0.005233608, -2.56],
        [0.005386146, -2.55],
        [0.005542623, -2.54],
        [0.005703126, -2.53],
        [0.005867742, -2.52],
        [0.006036558, -2.51],
        [0.006209665, -2.5],
        [0.006387155, -2.49],
        [0.006569119, -2.48],
        [0.006755653, -2.47],
        [0.006946851, -2.46],
        [0.007142811, -2.45],
        [0.007343631, -2.44],
        [0.007549411, -2.43],
        [0.007760254, -2.42],
        [0.00797626, -2.41],
        [0.008197536, -2.4],
        [0.008424186, -2.39],
        [0.008656319, -2.38],
        [0.008894043, -2.37],
        [0.009137468, -2.36],
        [0.009386706, -2.35],
        [0.00964187, -2.34],
        [0.009903076, -2.33],
        [0.010170439, -2.32],
        [0.010444077, -2.31],
        [0.01072411, -2.3],
        [0.011010658, -2.29],
        [0.011303844, -2.28],
        [0.011603792, -2.27],
        [0.011910625, -2.26],
        [0.012224473, -2.25],
        [0.012545461, -2.24],
        [0.012873721, -2.23],
        [0.013209384, -2.22],
        [0.013552581, -2.21],
        [0.013903448, -2.2],
        [0.014262118, -2.19],
        [0.014628731, -2.18],
        [0.015003423, -2.17],
        [0.015386335, -2.16],
        [0.015777607, -2.15],
        [0.016177383, -2.14],
        [0.016585807, -2.13],
        [0.017003023, -2.12],
        [0.017429178, -2.11],
        [0.017864421, -2.1],
        [0.0183089, -2.09],
        [0.018762766, -2.08],
        [0.019226172, -2.07],
        [0.01969927, -2.06],
        [0.020182215, -2.05],
        [0.020675163, -2.04],
        [0.02117827, -2.03],
        [0.021691694, -2.02],
        [0.022215594, -2.01],
        [0.022750132, -2],
        [0.023295468, -1.99],
        [0.023851764, -1.98],
        [0.024419185, -1.97],
        [0.024997895, -1.96],
        [0.02558806, -1.95],
        [0.026189845, -1.94],
        [0.026803419, -1.93],
        [0.02742895, -1.92],
        [0.028066607, -1.91],
        [0.02871656, -1.9],
        [0.02937898, -1.89],
        [0.030054039, -1.88],
        [0.030741909, -1.87],
        [0.031442763, -1.86],
        [0.032156775, -1.85],
        [0.032884119, -1.84],
        [0.033624969, -1.83],
        [0.034379502, -1.82],
        [0.035147894, -1.81],
        [0.035930319, -1.8],
        [0.036726956, -1.79],
        [0.03753798, -1.78],
        [0.03836357, -1.77],
        [0.039203903, -1.76],
        [0.040059157, -1.75],
        [0.040929509, -1.74],
        [0.041815138, -1.73],
        [0.042716221, -1.72],
        [0.043632937, -1.71],
        [0.044565463, -1.7],
        [0.045513977, -1.69],
        [0.046478658, -1.68],
        [0.047459682, -1.67],
        [0.048457226, -1.66],
        [0.049471468, -1.65],
        [0.050502583, -1.64],
        [0.051550748, -1.63],
        [0.052616138, -1.62],
        [0.053698928, -1.61],
        [0.054799292, -1.6],
        [0.055917403, -1.59],
        [0.057053433, -1.58],
        [0.058207556, -1.57],
        [0.059379941, -1.56],
        [0.060570758, -1.55],
        [0.061780177, -1.54],
        [0.063008364, -1.53],
        [0.064255488, -1.52],
        [0.065521712, -1.51],
        [0.066807201, -1.5],
        [0.068112118, -1.49],
        [0.069436623, -1.48],
        [0.070780877, -1.47],
        [0.072145037, -1.46],
        [0.07352926, -1.45],
        [0.0749337, -1.44],
        [0.07635851, -1.43],
        [0.077803841, -1.42],
        [0.079269841, -1.41],
        [0.080756659, -1.4],
        [0.082264439, -1.39],
        [0.083793322, -1.38],
        [0.085343451, -1.37],
        [0.086914962, -1.36],
        [0.088507991, -1.35],
        [0.090122672, -1.34],
        [0.091759136, -1.33],
        [0.093417509, -1.32],
        [0.095097918, -1.31],
        [0.096800485, -1.3],
        [0.098525329, -1.29],
        [0.100272568, -1.28],
        [0.102042315, -1.27],
        [0.103834681, -1.26],
        [0.105649774, -1.25],
        [0.107487697, -1.24],
        [0.109348552, -1.23],
        [0.111232437, -1.22],
        [0.113139446, -1.21],
        [0.11506967, -1.2],
        [0.117023196, -1.19],
        [0.119000107, -1.18],
        [0.121000484, -1.17],
        [0.123024403, -1.16],
        [0.125071936, -1.15],
        [0.127143151, -1.14],
        [0.129238112, -1.13],
        [0.131356881, -1.12],
        [0.133499513, -1.11],
        [0.135666061, -1.1],
        [0.137856572, -1.09],
        [0.14007109, -1.08],
        [0.142309654, -1.07],
        [0.1445723, -1.06],
        [0.146859056, -1.05],
        [0.14916995, -1.04],
        [0.151505003, -1.03],
        [0.15386423, -1.02],
        [0.156247645, -1.01],
        [0.158655254, -1],
        [0.16108706, -0.99],
        [0.163543059, -0.98],
        [0.166023246, -0.97],
        [0.168527607, -0.96],
        [0.171056126, -0.95],
        [0.17360878, -0.94],
        [0.176185542, -0.93],
        [0.17878638, -0.92],
        [0.181411255, -0.91],
        [0.184060125, -0.9],
        [0.186732943, -0.89],
        [0.189429655, -0.88],
        [0.192150202, -0.87],
        [0.194894521, -0.86],
        [0.197662543, -0.85],
        [0.200454193, -0.84],
        [0.203269392, -0.83],
        [0.206108054, -0.82],
        [0.208970088, -0.81],
        [0.211855399, -0.8],
        [0.214763884, -0.79],
        [0.217695438, -0.78],
        [0.220649946, -0.77],
        [0.223627292, -0.76],
        [0.226627352, -0.75],
        [0.229649997, -0.74],
        [0.232695092, -0.73],
        [0.235762498, -0.72],
        [0.238852068, -0.71],
        [0.241963652, -0.7],
        [0.245097094, -0.69],
        [0.24825223, -0.68],
        [0.251428895, -0.67],
        [0.254626915, -0.66],
        [0.257846111, -0.65],
        [0.2610863, -0.64],
        [0.264347292, -0.63],
        [0.267628893, -0.62],
        [0.270930904, -0.61],
        [0.274253118, -0.6],
        [0.277595325, -0.59],
        [0.280957309, -0.58],
        [0.284338849, -0.57],
        [0.287739719, -0.56],
        [0.291159687, -0.55],
        [0.294598516, -0.54],
        [0.298055965, -0.53],
        [0.301531788, -0.52],
        [0.305025731, -0.51],
        [0.308537539, -0.5],
        [0.312066949, -0.49],
        [0.315613697, -0.48],
        [0.319177509, -0.47],
        [0.32275811, -0.46],
        [0.32635522, -0.45],
        [0.329968554, -0.44],
        [0.333597821, -0.43],
        [0.337242727, -0.42],
        [0.340902974, -0.41],
        [0.344578258, -0.4],
        [0.348268273, -0.39],
        [0.351972708, -0.38],
        [0.355691245, -0.37],
        [0.359423567, -0.36],
        [0.363169349, -0.35],
        [0.366928264, -0.34],
        [0.370699981, -0.33],
        [0.374484165, -0.32],
        [0.378280478, -0.31],
        [0.382088578, -0.3],
        [0.385908119, -0.29],
        [0.389738752, -0.28],
        [0.393580127, -0.27],
        [0.397431887, -0.26],
        [0.401293674, -0.25],
        [0.405165128, -0.24],
        [0.409045885, -0.23],
        [0.412935577, -0.22],
        [0.416833837, -0.21],
        [0.420740291, -0.2],
        [0.424654565, -0.19],
        [0.428576284, -0.18],
        [0.432505068, -0.17],
        [0.436440537, -0.16],
        [0.440382308, -0.15],
        [0.444329995, -0.14],
        [0.448283213, -0.13],
        [0.452241574, -0.12],
        [0.456204687, -0.11],
        [0.460172163, -0.1],
        [0.464143607, -0.09],
        [0.468118628, -0.08],
        [0.47209683, -0.07],
        [0.476077817, -0.06],
        [0.480061194, -0.05],
        [0.484046563, -0.04],
        [0.488033527, -0.03],
        [0.492021686, -0.02],
        [0.496010644, -0.01],
        [0.5, 0],
        [0.503989356, 0.01],
        [0.507978314, 0.02],
        [0.511966473, 0.03],
        [0.515953437, 0.04],
        [0.519938806, 0.05],
        [0.523922183, 0.06],
        [0.52790317, 0.07],
        [0.531881372, 0.08],
        [0.535856393, 0.09],
        [0.539827837, 0.1],
        [0.543795313, 0.11],
        [0.547758426, 0.12],
        [0.551716787, 0.13],
        [0.555670005, 0.14],
        [0.559617692, 0.15],
        [0.563559463, 0.16],
        [0.567494932, 0.17],
        [0.571423716, 0.18],
        [0.575345435, 0.19],
        [0.579259709, 0.2],
        [0.583166163, 0.21],
        [0.587064423, 0.22],
        [0.590954115, 0.23],
        [0.594834872, 0.24],
        [0.598706326, 0.25],
        [0.602568113, 0.26],
        [0.606419873, 0.27],
        [0.610261248, 0.28],
        [0.614091881, 0.29],
        [0.617911422, 0.3],
        [0.621719522, 0.31],
        [0.625515835, 0.32],
        [0.629300019, 0.33],
        [0.633071736, 0.34],
        [0.636830651, 0.35],
        [0.640576433, 0.36],
        [0.644308755, 0.37],
        [0.648027292, 0.38],
        [0.651731727, 0.39],
        [0.655421742, 0.4],
        [0.659097026, 0.41],
        [0.662757273, 0.42],
        [0.666402179, 0.43],
        [0.670031446, 0.44],
        [0.67364478, 0.45],
        [0.67724189, 0.46],
        [0.680822491, 0.47],
        [0.684386303, 0.48],
        [0.687933051, 0.49],
        [0.691462461, 0.5],
        [0.694974269, 0.51],
        [0.698468212, 0.52],
        [0.701944035, 0.53],
        [0.705401484, 0.54],
        [0.708840313, 0.55],
        [0.712260281, 0.56],
        [0.715661151, 0.57],
        [0.719042691, 0.58],
        [0.722404675, 0.59],
        [0.725746882, 0.6],
        [0.729069096, 0.61],
        [0.732371107, 0.62],
        [0.735652708, 0.63],
        [0.7389137, 0.64],
        [0.742153889, 0.65],
        [0.745373085, 0.66],
        [0.748571105, 0.67],
        [0.75174777, 0.68],
        [0.754902906, 0.69],
        [0.758036348, 0.7],
        [0.761147932, 0.71],
        [0.764237502, 0.72],
        [0.767304908, 0.73],
        [0.770350003, 0.74],
        [0.773372648, 0.75],
        [0.776372708, 0.76],
        [0.779350054, 0.77],
        [0.782304562, 0.78],
        [0.785236116, 0.79],
        [0.788144601, 0.8],
        [0.791029912, 0.81],
        [0.793891946, 0.82],
        [0.796730608, 0.83],
        [0.799545807, 0.84],
        [0.802337457, 0.85],
        [0.805105479, 0.86],
        [0.807849798, 0.87],
        [0.810570345, 0.88],
        [0.813267057, 0.89],
        [0.815939875, 0.9],
        [0.818588745, 0.91],
        [0.82121362, 0.92],
        [0.823814458, 0.93],
        [0.82639122, 0.94],
        [0.828943874, 0.95],
        [0.831472393, 0.96],
        [0.833976754, 0.97],
        [0.836456941, 0.98],
        [0.83891294, 0.99],
        [0.841344746, 1],
        [0.843752355, 1.01],
        [0.84613577, 1.02],
        [0.848494997, 1.03],
        [0.85083005, 1.04],
        [0.853140944, 1.05],
        [0.8554277, 1.06],
        [0.857690346, 1.07],
        [0.85992891, 1.08],
        [0.862143428, 1.09],
        [0.864333939, 1.1],
        [0.866500487, 1.11],
        [0.868643119, 1.12],
        [0.870761888, 1.13],
        [0.872856849, 1.14],
        [0.874928064, 1.15],
        [0.876975597, 1.16],
        [0.878999516, 1.17],
        [0.880999893, 1.18],
        [0.882976804, 1.19],
        [0.88493033, 1.2],
        [0.886860554, 1.21],
        [0.888767563, 1.22],
        [0.890651448, 1.23],
        [0.892512303, 1.24],
        [0.894350226, 1.25],
        [0.896165319, 1.26],
        [0.897957685, 1.27],
        [0.899727432, 1.28],
        [0.901474671, 1.29],
        [0.903199515, 1.3],
        [0.904902082, 1.31],
        [0.906582491, 1.32],
        [0.908240864, 1.33],
        [0.909877328, 1.34],
        [0.911492009, 1.35],
        [0.913085038, 1.36],
        [0.914656549, 1.37],
        [0.916206678, 1.38],
        [0.917735561, 1.39],
        [0.919243341, 1.4],
        [0.920730159, 1.41],
        [0.922196159, 1.42],
        [0.92364149, 1.43],
        [0.9250663, 1.44],
        [0.92647074, 1.45],
        [0.927854963, 1.46],
        [0.929219123, 1.47],
        [0.930563377, 1.48],
        [0.931887882, 1.49],
        [0.933192799, 1.5],
        [0.934478288, 1.51],
        [0.935744512, 1.52],
        [0.936991636, 1.53],
        [0.938219823, 1.54],
        [0.939429242, 1.55],
        [0.940620059, 1.56],
        [0.941792444, 1.57],
        [0.942946567, 1.58],
        [0.944082597, 1.59],
        [0.945200708, 1.6],
        [0.946301072, 1.61],
        [0.947383862, 1.62],
        [0.948449252, 1.63],
        [0.949497417, 1.64],
        [0.950528532, 1.65],
        [0.951542774, 1.66],
        [0.952540318, 1.67],
        [0.953521342, 1.68],
        [0.954486023, 1.69],
        [0.955434537, 1.7],
        [0.956367063, 1.71],
        [0.957283779, 1.72],
        [0.958184862, 1.73],
        [0.959070491, 1.74],
        [0.959940843, 1.75],
        [0.960796097, 1.76],
        [0.96163643, 1.77],
        [0.96246202, 1.78],
        [0.963273044, 1.79],
        [0.964069681, 1.8],
        [0.964852106, 1.81],
        [0.965620498, 1.82],
        [0.966375031, 1.83],
        [0.967115881, 1.84],
        [0.967843225, 1.85],
        [0.968557237, 1.86],
        [0.969258091, 1.87],
        [0.969945961, 1.88],
        [0.97062102, 1.89],
        [0.97128344, 1.9],
        [0.971933393, 1.91],
        [0.97257105, 1.92],
        [0.973196581, 1.93],
        [0.973810155, 1.94],
        [0.97441194, 1.95],
        [0.975002105, 1.96],
        [0.975580815, 1.97],
        [0.976148236, 1.98],
        [0.976704532, 1.99],
        [0.977249868, 2],
        [0.977784406, 2.01],
        [0.978308306, 2.02],
        [0.97882173, 2.03],
        [0.979324837, 2.04],
        [0.979817785, 2.05],
        [0.98030073, 2.06],
        [0.980773828, 2.07],
        [0.981237234, 2.08],
        [0.9816911, 2.09],
        [0.982135579, 2.1],
        [0.982570822, 2.11],
        [0.982996977, 2.12],
        [0.983414193, 2.13],
        [0.983822617, 2.14],
        [0.984222393, 2.15],
        [0.984613665, 2.16],
        [0.984996577, 2.17],
        [0.985371269, 2.18],
        [0.985737882, 2.19],
        [0.986096552, 2.2],
        [0.986447419, 2.21],
        [0.986790616, 2.22],
        [0.987126279, 2.23],
        [0.987454539, 2.24],
        [0.987775527, 2.25],
        [0.988089375, 2.26],
        [0.988396208, 2.27],
        [0.988696156, 2.28],
        [0.988989342, 2.29],
        [0.98927589, 2.3],
        [0.989555923, 2.31],
        [0.989829561, 2.32],
        [0.990096924, 2.33],
        [0.99035813, 2.34],
        [0.990613294, 2.35],
        [0.990862532, 2.36],
        [0.991105957, 2.37],
        [0.991343681, 2.38],
        [0.991575814, 2.39],
        [0.991802464, 2.4],
        [0.99202374, 2.41],
        [0.992239746, 2.42],
        [0.992450589, 2.43],
        [0.992656369, 2.44],
        [0.992857189, 2.45],
        [0.993053149, 2.46],
        [0.993244347, 2.47],
        [0.993430881, 2.48],
        [0.993612845, 2.49],
        [0.993790335, 2.5],
        [0.993963442, 2.51],
        [0.994132258, 2.52],
        [0.994296874, 2.53],
        [0.994457377, 2.54],
        [0.994613854, 2.55],
        [0.994766392, 2.56],
        [0.994915074, 2.57],
        [0.995059984, 2.58],
        [0.995201203, 2.59],
        [0.995338812, 2.6],
        [0.995472889, 2.61],
        [0.995603512, 2.62],
        [0.995730757, 2.63],
        [0.995854699, 2.64],
        [0.995975411, 2.65],
        [0.996092967, 2.66],
        [0.996207438, 2.67],
        [0.996318892, 2.68],
        [0.996427399, 2.69],
        [0.996533026, 2.7],
        [0.99663584, 2.71],
        [0.996735904, 2.72],
        [0.996833284, 2.73],
        [0.996928041, 2.74],
        [0.997020237, 2.75],
        [0.997109932, 2.76],
        [0.997197185, 2.77],
        [0.997282055, 2.78],
        [0.997364598, 2.79],
        [0.99744487, 2.8],
        [0.997522925, 2.81],
        [0.997598818, 2.82],
        [0.9976726, 2.83],
        [0.997744323, 2.84],
        [0.997814039, 2.85],
        [0.997881795, 2.86],
        [0.997947641, 2.87],
        [0.998011624, 2.88],
        [0.998073791, 2.89],
        [0.998134187, 2.9],
        [0.998192856, 2.91],
        [0.998249843, 2.92],
        [0.99830519, 2.93],
        [0.998358939, 2.94],
        [0.99841113, 2.95],
        [0.998461805, 2.96],
        [0.998511001, 2.97],
        [0.998558758, 2.98],
        [0.998605113, 2.99],
        [0.998650102, 3],
        [0.998693762, 3.01],
        [0.998736127, 3.02],
        [0.998777231, 3.03],
        [0.998817109, 3.04],
        [0.998855793, 3.05],
        [0.998893315, 3.06],
        [0.998929706, 3.07],
        [0.998964997, 3.08],
        [0.998999218, 3.09],
        [0.999032397, 3.1],
        [0.999064563, 3.11],
        [0.999095745, 3.12],
        [0.999125968, 3.13],
        [0.999155261, 3.14],
        [0.999183648, 3.15],
        [0.999211154, 3.16],
        [0.999237805, 3.17],
        [0.999263625, 3.18],
        [0.999288636, 3.19],
        [0.999312862, 3.2],
        [0.999336325, 3.21],
        [0.999359047, 3.22],
        [0.999381049, 3.23],
        [0.999402352, 3.24],
        [0.999422975, 3.25],
        [0.999442939, 3.26],
        [0.999462263, 3.27],
        [0.999480965, 3.28],
        [0.999499063, 3.29],
        [0.999516576, 3.3],
        [0.99953352, 3.31],
        [0.999549913, 3.32],
        [0.99956577, 3.33],
        [0.999581108, 3.34],
        [0.999595942, 3.35],
        [0.999610288, 3.36],
        [0.999624159, 3.37],
        [0.999637571, 3.38],
        [0.999650537, 3.39],
        [0.999663071, 3.4],
        [0.999675186, 3.41],
        [0.999686894, 3.42],
        [0.999698209, 3.43],
        [0.999709143, 3.44],
        [0.999719707, 3.45],
        [0.999729912, 3.46],
        [0.999739771, 3.47],
        [0.999749293, 3.48],
        [0.99975849, 3.49],
        [0.999767371, 3.5]]);


</script>

<style lang="scss">
#generate
{
    .mdl-textfield
    {
        width:70px !important;
        padding-bottom:0;
    }
    .mdl-button
    {
        margin:5px;
        top:-6px;
    }
    .mini
    {
        width:68px;    
    }
    h3
    {
        font-size:18px;
        margin-top:0;
        margin-bottom:0;
    }
    .label{
        width:100px;
        display:inline-block;
        
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
        text-orientation:upright;
        font-size:12px;
        color:#666;
        flex-basis: 20px;
    }

    .border
    {
        border-top:1px solid rgba(0,0,0,0.2);
        padding:30px;
    }

    .generated-height{
        font-size:30px;
    }

    
    .flex{
        display:flex;
        align-items: center;
        margin:5px 0;

        .mdl-button--raised{
            flex:1;
            margin:0 3px;
            min-width:auto;
            padding:0;
            font-size:12px;
        }

        .mdl-textfield{
            padding:0;
            
        }

    }
}

</style>


// WEBPACK FOOTER //
// Generate.vue?0864ce50